module.exports = __webpack_public_path__ + "logo_digitalfactory.jpg?31d61b9bbd832ff03c4dc3de1a072368";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/logo_digitalfactory.jpg
// module id = 56
// module chunks = 0